/**
 * Утилита для преобразования URL'ов через прокси в режиме разработки
 * В продакшене возвращает оригинальный URL
 */

const S3_PROD_URL = 'https://eatsy-games-defaults-prod.s3.eu-central-1.amazonaws.com';
const S3_DEV_URL = 'https://eatsy-games-defaults-dev.s3.eu-central-1.amazonaws.com';
const CLOUDFRONT_URL = 'https://d1j6i488z7taiq.cloudfront.net';

/**
 * Преобразует URL для использования через прокси.
 * В обычном режиме в продакшене возвращает оригинальный URL, но при forceProxy
 * принудительно проксирует, чтобы обойти CORS (актуально для CloudFront/S3).
 * @param url - оригинальный URL
 * @param forceProxy - принудительно использовать прокси даже в PROD
 */
export const getProxyUrl = (url: string, forceProxy = false): string => {
  const shouldProxy = forceProxy || !import.meta.env.PROD;

  if (!shouldProxy) {
    return url;
  }

  if (url.startsWith(S3_PROD_URL)) {
    return url.replace(S3_PROD_URL, '/s3-prod');
  }

  if (url.startsWith(S3_DEV_URL)) {
    return url.replace(S3_DEV_URL, '/s3-dev');
  }

  if (url.startsWith(CLOUDFRONT_URL)) {
    return url.replace(CLOUDFRONT_URL, '/cloudfront');
  }

  // Если URL не соответствует ни одному из доменов, возвращаем как есть
  return url;
};

/**
 * Преобразует массив URL'ов
 * @param urls - массив URL'ов
 * @returns массив преобразованных URL'ов
 */
export const getProxyUrls = (urls: string[]): string[] => {
  return urls.map(url => getProxyUrl(url));
};

/**
 * Преобразует URL или массив URL'ов
 * @param urlOrUrls - URL или массив URL'ов
 * @returns преобразованный URL или массив URL'ов
 */
export const getProxyUrlOrUrls = (urlOrUrls: string | string[]): string | string[] => {
  if (Array.isArray(urlOrUrls)) {
    return getProxyUrls(urlOrUrls);
  }
  return getProxyUrl(urlOrUrls);
};
